import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  TextField,
  Card,
  Typography,
  FormHelperText,
  CircularProgress,
  Box,
  Stack,
  InputAdornment,
  IconButton,
  MenuItem,
  Select,
  Switch,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { openSnackbar, uploadImage } from "../../../redux/slices/common";
import { AccountCircle } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import CommonQuillEditor from "common/editor";
import { grey } from "@mui/material/colors";
import AngleRightIcon from "common/customIcons/angle_right";
import { getTraitListing } from "../../../redux/slices/traitSlice";
import { deleteSubTrait, updateSubTrait } from "../../../redux/slices/subtraitSlice";
import { addSubTrait } from "../../../redux/slices/subtraitSlice";
import { useSearchParams } from "react-router-dom";
import Loader from "common/Loader";
import DeleteIcon from "common/customIcons/delete";
import { subTraitValidation } from "validations/subtraitValidation";
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from "../../../redux/slices/modalSlice";
import { getData } from "utilities/common";
import { getPermissionsByMode } from "utilities/common";
import { hasSectionPermission } from "utilities/common";

const circularProgressIcon = {
  backgroundColor: "#fff",
  borderRadius: 10,
  p: 0.5,
  position: "absolute",
};

const AddSubTraitForm = () => {
  const { user } = useSelector((state) => state.auth);

  const { subTraitDetails: subTrait = {}, isLoading = false } = useSelector(
    (state) => state.subtraitSlice
  );
  const { loading } = useSelector((state) => state.subtraitSlice);
  const { isUploading = false } = useSelector((state) => state.common);
  const { subtraitSlug = "" } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isToggleOn, setIsToggleOn] = useState({
    all: false,
    hemp: false,
    hyperwolf: false,
  });
  const [isProductSlug, setIsProductSlugData] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => {
    return searchParams.get("roleTab") || "hemp";
  }, [searchParams, subtraitSlug]);
  const [mainTrait, setMainTrait] = useState([]);
  const [formData, setFormData] = useState({
    data: {
      hemp: {
        title: "",
        description1: "",
        description2: "",
        metaTitle: "",
        metaDescription: "",
        status: "Active",
        subTraitName: "",
        createdBy: user?.name,
        detailImageAlt: "",
        listImageAlt: "",
        parentTrait: "",
        traitId: "",
        listImage: "",
        detailImage: "",
        desktopIcon: "",
        mobileIcon: "",
        showOnHomePage: false,
        tags: [],
        traitSlug: "",
        traitHeading: ""
      },
      hyperwolf: {
        title: "",
        description1: "",
        description2: "",
        metaTitle: "",
        metaDescription: "",
        status: "Active",
        subTraitName: "",
        createdBy: user?.name,
        detailImageAlt: "",
        listImageAlt: "",
        parentTrait: "",
        traitId: "",
        listImage: "",
        detailImage: "",
        desktopIcon: "",
        mobileIcon: "",
        showOnHomePage: false,
        tags: [],
        traitSlug: "",
        traitHeading: ""
      },
      stilo: {
        title: "",
        description1: "",
        description2: "",
        metaTitle: "",
        metaDescription: "",
        status: "Active",
        subTraitName: "",
        createdBy: user?.name,
        detailImageAlt: "",
        listImageAlt: "",
        parentTrait: "",
        traitId: "",
        listImage: "",
        detailImage: "",
        desktopIcon: "",
        mobileIcon: "",
        showOnHomePage: false,
        tags: [],
        traitSlug: "",
        traitHeading: ""

      },
    },
  });

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Product", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Product", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Product", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Product", "Delete");

  useEffect(() => {
    if (user?.name) {
      setFormData((prev) => ({
        ...prev,
        data: {
          hemp: { ...prev.data.hemp, createdBy: user.name },
          hyperwolf: { ...prev.data.hyperwolf, createdBy: user.name },
          stilo: { ...prev.data.stilo, createdBy: user.name },
        },
      }));
    }
  }, [user?.name]);

  const currentImageUploadFieldRef = useRef();
  const [errors, setErrors] = useState();
  const [linkState, setLinkState] = useState("");

  useEffect(() => {
    if (subtraitSlug && !searchParams.has("roleTab")) {
      const updatedParams = new URLSearchParams(searchParams);
      updatedParams.set("roleTab", "hemp");

      navigate(`?${updatedParams.toString()}`, { replace: true });
    }
  }, [subtraitSlug, searchParams, navigate]);

  useEffect(() => {
    setTimeout(() => {
      setLinkState("");
    }, 1000);
  }, [linkState]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "traitSlug") {
      setIsProductSlugData(true);
    }

    setFormData((prevData) => {
      const updatedData = { ...prevData.data };

      // Update only the selected platform's subTraitName
      updatedData[fullRoleTab] = {
        ...updatedData[fullRoleTab],
        [name]: value,
      };

      // Automatically update subTraitName for all platforms when one is changed
      if (name === "subTraitName") {
        Object.keys(updatedData).forEach((platform) => {
          if (platform !== fullRoleTab) {
            updatedData[platform] = {
              ...updatedData[platform],
              subTraitName: value, // Ensure all platforms reflect the same subTraitName
            };
          }
        });
      }
      if (name === "parentTrait") {
        Object.keys(updatedData).forEach((platform) => {
          if (platform !== fullRoleTab) {
            updatedData[platform] = {
              ...updatedData[platform],
              parentTrait: value, // Ensure all platforms reflect the same subTraitName
            };
          }
        });
      }
      return { ...prevData, data: updatedData };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = subTraitValidation(formData, fullRoleTab);
    if (!isValid) {
      setErrors(errors);
      return;
    }

    // If form is valid, clear errors
    setErrors({});

    const payload = {
      data: {
        [fullRoleTab]: formData.data[fullRoleTab],
      },
    };


    if (subtraitSlug) {

      const updatedPayload = { ...payload };

      // Add 'updatedBy' and remove 'traitSlug' and 'canonical' temporarily
      updatedPayload.data[fullRoleTab] = {
        ...updatedPayload.data[fullRoleTab],
        updatedBy: user?.name || "",
      };
      if (!isProductSlug) {
        delete updatedPayload.data[fullRoleTab].traitSlug;
      }
      delete updatedPayload.data[fullRoleTab].traitSlugArray;
      delete updatedPayload.data[fullRoleTab].canonical;


      dispatch(updateSubTrait({ data: updatedPayload, slug: subtraitSlug, userType: "admin" }))
        .unwrap()
        .then((res) => {
          showResponseMessage(res?.data?.message, "success");
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    } else {
      dispatch(addSubTrait(payload))
        .unwrap()
        .then((res) => {
          showResponseMessage(res?.message, "success");
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    }
  };

  const showResponseMessage = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };

  useEffect(() => {
    if (subtraitSlug && Object.keys(subTrait).length > 0) {
      // Ensure the `subTraitName`, `parentTrait`, and `traitId` are correctly populated for each platform
      const subTraitName =
        subTrait.data?.hemp?.subTraitName ||
        subTrait.data?.hyperwolf?.subTraitName ||
        subTrait.data?.stilo?.subTraitName;

      const parentTrait =
        subTrait.data?.hemp?.parentTrait ||
        subTrait.data?.hyperwolf?.parentTrait ||
        subTrait.data?.stilo?.parentTrait;
      // const traitId = subTrait.data?.hemp?.traitId ||
      //                 subTrait.data?.hyperwolf?.traitId ||
      //                 subTrait.data?.stilo?.traitId;

      setFormData((prevData) => {
        const updatedData = {
          hemp: {
            ...prevData.data.hemp,
            ...subTrait.data.hemp, // Populate hemp data
            subTraitName: subTraitName, // Set subTraitName for hemp
            parentTrait: parentTrait, // Set parentTrait for hemp
            // traitId: traitId, // Set traitId for hemp
          },
          hyperwolf: {
            ...prevData.data.hyperwolf,
            ...subTrait.data.hyperwolf, // Populate hyperwolf data
            subTraitName: subTraitName, // Set subTraitName for hyperwolf
            parentTrait: parentTrait, // Set parentTrait for hyperwolf
            // traitId: traitId, // Set traitId for hyperwolf
          },
          stilo: {
            ...prevData.data.stilo,
            ...subTrait.data.stilo, // Populate stilo data
            subTraitName: subTraitName, // Set subTraitName for stilo
            parentTrait: parentTrait, // Set parentTrait for stilo
            // traitId: traitId, // Set traitId for stilo
          },
        };

        return { data: updatedData };
      });
    }
  }, [subTrait, subtraitSlug]); // Added `subtraitSlug` as a dependency if needed

  const uploadThumbnailImage = {
    borderRadius: "20px",
    width: "160px",
    height: "160px",
    objectFit: "cover",
    boxShadow: "0 0 1px rgb(0 0 0 / 20%)",
  };

  const listImageUploadHandler = async (e) => {
    currentImageUploadFieldRef.current = "list_image"; // Update for list image

    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append("filePath", file);

      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          let newErrors = { ...errors };
          delete newErrors.listImage; // Delete any previous error
          setErrors(newErrors);

          setFormData((prevData) => {
            // Update only the selected platform's list image
            return {
              ...prevData,
              data: {
                ...prevData.data,
                [fullRoleTab]: {
                  ...prevData.data[fullRoleTab],
                  listImage: res.fileUrl,
                },
              },
            };
          });
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    }
  };

  const handleDeleteListImage = () => {
    setFormData((prevData) => ({
      ...prevData,
      data: {
        ...prevData.data,
        [fullRoleTab]: {
          ...prevData.data[fullRoleTab],
          listImage: null, // or '' depending on your data structure
        },
      },
    }));
  };

  const detailPageImageUploadHandler = async (e) => {
    currentImageUploadFieldRef.current = "detail_page_image";

    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append("filePath", file);

      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          let newErrors = { ...errors };
          delete newErrors.detailImage; // Delete previous error
          setErrors(newErrors);

          setFormData((prevData) => {
            // Update only the selected platform's detail image
            return {
              ...prevData,
              data: {
                ...prevData.data,
                [fullRoleTab]: {
                  ...prevData.data[fullRoleTab],
                  detailImage: res.fileUrl,
                },
              },
            };
          });
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    }
  };

  const handleDeleteDetailImage = () => {
    setFormData((prevData) => ({
      ...prevData,
      data: {
        ...prevData.data,
        [fullRoleTab]: {
          ...prevData.data[fullRoleTab],
          detailImage: null, // or '' depending on your data structure
        },
      },
    }));
  };

  const desktopIconUploadHandler = async (e) => {
    currentImageUploadFieldRef.current = "desktop_icon";

    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append("filePath", file);

      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          let newErrors = { ...errors };
          delete newErrors.desktopIcon; // Delete previous error
          setErrors(newErrors);

          setFormData((prevData) => {
            // Update only the selected platform's desktop icon
            return {
              ...prevData,
              data: {
                ...prevData.data,
                [fullRoleTab]: {
                  ...prevData.data[fullRoleTab],
                  desktopIcon: res.fileUrl,
                },
              },
            };
          });
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    }
  };

  const handleDeleteDesktopIcon = () => {
    setFormData((prevData) => ({
      ...prevData,
      data: {
        ...prevData.data,
        [fullRoleTab]: {
          ...prevData.data[fullRoleTab],
          desktopIcon: null, // or '' depending on your data structure
        },
      },
    }));
  };

  const mobileIconUploadHandler = async (e) => {
    currentImageUploadFieldRef.current = "mobile_icon";

    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append("filePath", file);

      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          let newErrors = { ...errors };
          delete newErrors.mobileIcon; // Delete previous error
          setErrors(newErrors);

          setFormData((prevData) => {
            // Update only the selected platform's mobile icon
            return {
              ...prevData,
              data: {
                ...prevData.data,
                [fullRoleTab]: {
                  ...prevData.data[fullRoleTab],
                  mobileIcon: res.fileUrl,
                },
              },
            };
          });
        })
        .catch((err) => {
          showResponseMessage(err?.message, "error");
        });
    }
  };

  const handleDeleteMobileIcon = () => {
    setFormData((prevData) => ({
      ...prevData,
      data: {
        ...prevData.data,
        [fullRoleTab]: {
          ...prevData.data[fullRoleTab],
          mobileIcon: null, // or '' depending on your data structure
        },
      },
    }));
  };

  const handleToggle = () => {
    setIsToggleOn((prevState) => {
      // Make a copy of the previous state to avoid mutation
      let newState = { ...prevState };

      if (newState.hasOwnProperty(fullRoleTab)) {
        // Toggle only the specific platform state (e.g. hemp, hyperwolf)
        newState[fullRoleTab] = !prevState[fullRoleTab];
      }

      return newState; // Return the updated state
    });

    setFormData((prevData) => {
      // Update the specific platform's showOnHomePage toggle
      return {
        ...prevData,
        data: {
          ...prevData.data,
          [fullRoleTab]: {
            ...prevData.data[fullRoleTab], // Retain other platform data
            showOnHomePage: !prevData.data[fullRoleTab]?.showOnHomePage, // Toggle showOnHomePage only for the selected platform
          },
        },
      };
    });
  };

  useEffect(() => {
    setIsProductSlugData(false)
  }, [fullRoleTab])

  useEffect(() => {
    const fetchParentTraits = async () => {
      try {
        const parentTraitsResponse = await dispatch(getTraitListing({ platformType: fullRoleTab })).unwrap();
        setMainTrait(parentTraitsResponse.traits);
      } catch (error) { }
    };

    fetchParentTraits();
  }, [fullRoleTab]);


  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };


  const deleteHandler = (deleteId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteSubTrait({ slug: deleteId, platform: fullRoleTab }))
      .unwrap()
      .then((res) => {
        showError(res?.data?.message, "success");
        dispatch(closeCustomModalDialog());
        navigate('/product_traits/subtrait')
      })
      .catch((err) => {
        dispatch(setModalLoader(false));
        showError(err?.message, "error");
      });
  };


  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box p={4}>
          {/********************** Top Back Section **********************/}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ sm: "center" }}
            justifyContent="space-between"
            gap={2}
            mb={2}
          >
            <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
              <IconButton onClick={() => navigate("/product_traits/subtrait")}>
                <AngleRightIcon fontSize="14px" />
              </IconButton>
              <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                {subtraitSlug ? "Edit" : "Add"}{" "}
                {formData?.data?.[fullRoleTab]?.showOnHomePage ? "Sub Trait" : "Minor Trait"}
              </Typography>
            </Box>

            <Stack
              direction="row"
              alignItems="center"
              gap={0.75}
              lineHeight={1}
              p={0.75}
              borderRadius={2}
              bgcolor="#F2F3F7"
            >
              {/* Active Button */}
              <MDButton
                sx={{
                  minWidth: "92px",
                  borderRadius: 1.75,
                  minHeight: "28px",
                  p: 0.25,
                  fontWeight: 500,
                }}
                type="button"
                variant={
                  formData.data[fullRoleTab]?.status === "Active" || fullRoleTab === "all"
                    ? "contained"
                    : "text"
                }
                color={
                  formData.data[fullRoleTab]?.status === "Active" || fullRoleTab === "all"
                    ? "success"
                    : "dark"
                }
                size="small"
                onClick={() => {
                  if (fullRoleTab === "all") {
                    // Set all platforms' status to "Active"
                    setFormData((prevData) => {
                      const updatedData = { ...prevData.data };
                      Object.keys(updatedData).forEach((platform) => {
                        updatedData[platform] = {
                          ...updatedData[platform],
                          status: "Active",
                        };
                      });
                      return {
                        ...prevData,
                        data: updatedData,
                      };
                    });
                  } else {
                    // Set the specific platform's status to "Active"
                    setFormData((prevData) => ({
                      ...prevData,
                      data: {
                        ...prevData.data,
                        [fullRoleTab]: {
                          ...prevData.data[fullRoleTab],
                          status: "Active",
                        },
                      },
                    }));
                  }
                }}
              >
                Active
              </MDButton>

              {/* Inactive Button */}
              <MDButton
                sx={{
                  minWidth: "92px",
                  borderRadius: 1.75,
                  minHeight: "28px",
                  p: 0.25,
                  fontWeight: 500,
                }}
                type="button"
                variant={
                  formData.data[fullRoleTab]?.status !== "Active" && fullRoleTab !== "all"
                    ? "contained"
                    : "text"
                }
                color={
                  formData.data[fullRoleTab]?.status !== "Active" && fullRoleTab !== "all"
                    ? "error"
                    : "dark"
                }
                size="small"
                onClick={() => {
                  if (fullRoleTab === "all") {
                    // Set all platforms' status to "Inactive"
                    setFormData((prevData) => {
                      const updatedData = { ...prevData.data };
                      Object.keys(updatedData).forEach((platform) => {
                        updatedData[platform] = {
                          ...updatedData[platform],
                          status: "Inactive",
                        };
                      });
                      return {
                        ...prevData,
                        data: updatedData,
                      };
                    });
                  } else {
                    // Set the specific platform's status to "Inactive"
                    setFormData((prevData) => ({
                      ...prevData,
                      data: {
                        ...prevData.data,
                        [fullRoleTab]: {
                          ...prevData.data[fullRoleTab],
                          status: "Inactive",
                        },
                      },
                    }));
                  }
                }}
              >
                Inactive
              </MDButton>
            </Stack>
          </Stack>

          <Stack direction="row" justifyContent="space-between" gap={1} className="mb-0">
            <Box
              className="w-100 d-flex jc-s-btwn gap-2 cannabinoids-tabs"
              style={{ marginBottom: "20px" }}
            >
              <Stack direction="row" gap={1} sx={{ background: "#ffffff" }} className="mb-0">


                <Button
                  className={fullRoleTab === "hemp" ? "active" : ""}
                  onClick={() => {
                    setSearchParams({ roleTab: "hemp" });
                    // Update only the data for the "hemp" platform
                    setFormData((prevData) => ({
                      ...prevData,
                      data: {
                        // Ensure only `data` is updated
                        ...prevData.data,
                        hemp: { ...prevData.data.hemp }, // Copy `hemp` platform data only
                      },
                    }));
                  }}
                  variant="outlined"
                  sx={{ color: "#2E2E3A", minWidth: "160px" }}
                >
                  Hemp
                </Button>

                <Button
                  onClick={() => {
                    setSearchParams({ roleTab: "hyperwolf" });
                    // Update only the data for the "hyperwolf" platform
                    setFormData((prevData) => ({
                      ...prevData,
                      data: {
                        // Ensure only `data` is updated
                        ...prevData.data,
                        hyperwolf: { ...prevData.data.hyperwolf }, // Copy `hyperwolf` platform data only
                      },
                    }));
                  }}
                  variant="outlined"
                  sx={{ color: "#2E2E3A", minWidth: "160px" }}
                  className={fullRoleTab === "hyperwolf" ? "active" : ""}
                >
                  Hyperwolf
                </Button>

                <Button
                  className={fullRoleTab === "stilo" ? "active" : ""}
                  onClick={() => {
                    setSearchParams({ roleTab: "stilo" });
                    // Update only the data for the "stilo" platform
                    setFormData((prevData) => ({
                      ...prevData,
                      data: {
                        // Ensure only `data` is updated
                        ...prevData.data,
                        stilo: { ...prevData.data.stilo }, // Copy `stilo` platform data only
                      },
                    }));
                  }}
                  variant="outlined"
                  sx={{ color: "#2E2E3A", minWidth: "160px" }}
                // disabled
                >
                  Stilo
                </Button>
              </Stack>
              {subtraitSlug && formData?.data?.[fullRoleTab]?.canonical && (
                <Box
                  display="flex"
                  sx={{ cursor: "pointer" }}
                  alignItems="center"
                  color="text.main"
                  lineHeight={1}
                  gap={2}
                  style={{ position: "relative" }}
                >
                  <svg
                    style={{ cursor: "pointer" }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    onClick={() => {
                      const link = formData?.data?.[fullRoleTab]?.canonical;
                      navigator.clipboard
                        .writeText(link)
                        .then(() => setLinkState("Link copied!"))
                        .catch((err) => { });
                    }}
                  >
                    <g clipPath="url(#clip0_14557_35992)">
                      <path
                        d="M8.61203 16.7513C6.65952 16.7513 5.07031 15.162 5.07031 13.2095V4.66797H3.61203C2.34784 4.66797 1.32031 5.69534 1.32031 6.95953V18.2095C1.32031 19.4737 2.34784 20.5013 3.61203 20.5013H14.0286C15.2928 20.5013 16.3203 19.4737 16.3203 18.2095V16.7513H8.61203Z"
                        fill="#0163FF"
                      />
                      <path
                        d="M19.6536 2.79172C19.6536 1.52585 18.6277 0.5 17.362 0.5H8.61203C7.34616 0.5 6.32031 1.52585 6.32031 2.79172V13.2083C6.32031 14.4742 7.34616 15.5 8.61203 15.5H17.362C18.6277 15.5 19.6536 14.4742 19.6536 13.2083V2.79172Z"
                        fill="#0163FF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14557_35992">
                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                  {linkState && <p className="link-status">{linkState}</p>}
                  <Typography
                    variant="body"
                    component="a"
                    href={
                      formData.data?.[fullRoleTab].canonical
                        ? formData.data?.[fullRoleTab].canonical
                        : ""
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ textDecoration: "none", color: "inherit" }}
                    style={{
                      borderRadius: "26px",
                      color: "#0163FF",
                      fontSize: "14px",
                      fontWeight: "400",
                      border: "1px solid #0163FF",
                      padding: "10px 16px",
                    }}
                  >
                    {formData.data?.[fullRoleTab].canonical
                      ? formData.data?.[fullRoleTab].canonical
                      : ""}
                  </Typography>
                </Box>
              )}
            </Box>
          </Stack>

          <Grid item xs={12}>
            <Stack direction="row" alignItems="center" mb={2}>
              <Switch
                checked={
                  fullRoleTab === "all"
                    ? isToggleOn.all &&
                    Object.values(formData?.data || {}).every(
                      (platform) => platform?.showOnHomePage
                    )
                    : formData?.data?.[fullRoleTab]?.showOnHomePage
                }
                name="validity"
                onChange={handleToggle}
              />
              <Typography variant="body2" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                Show on Home Page
              </Typography>
            </Stack>
          </Grid>

          {/********************** Page Details **********************/}
          <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
            <Typography variant="h5" fontWeight="semibold" mb={2}>{`${formData?.data?.[fullRoleTab]?.showOnHomePage
              ? "Page Details"
              : "Product Page Details"
              }`}</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  className="form-input created-by p-l-field bg-transparent"
                  label="Sub Trait Name*"
                  fullWidth
                  placeholder="Sub Trait Name"
                  disabled={subtraitSlug ? true : false}
                  name="subTraitName"
                  value={
                    formData?.data?.[fullRoleTab]?.subTraitName ||
                    Object.values(formData?.data || {}).find((platform) => platform.subTraitName)
                      ?.subTraitName ||
                    ""
                  }
                  onChange={handleInputChange}
                  error={Boolean(errors?.[fullRoleTab]?.subTraitName)} // Check if there's an error for this platform
                  helperText={errors?.[fullRoleTab]?.subTraitName}
                />
              </Grid>

              {formData?.data?.[fullRoleTab]?.showOnHomePage && (
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Select Parent Trait</InputLabel>
                    <Select
                      className="form-select"
                      value={
                        formData?.data?.[fullRoleTab]?.parentTrait ||
                        Object.values(formData?.data || {}).find((platform) => platform.parentTrait)
                          ?.parentTrait ||
                        ""
                      } // Show parentTrait if it exists in any platform
                      name="parentTrait"
                      onChange={(e) => handleInputChange(e, fullRoleTab)} // Pass fullRoleTab to handle which platform to update
                      displayEmpty
                      fullWidth
                      variant="outlined"
                      label="Select Parent Trait"
                    >
                      {mainTrait.map((item, index) => (
                        <MenuItem key={index} value={item.mainTraitName}>
                          {item.mainTraitName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} md={4}>
                <TextField
                  className="form-input created-by"
                  label="Created By"
                  fullWidth
                  variant="outlined"
                  name="createdBy"
                  disabled
                  value={
                    fullRoleTab === "all"
                      ? formData.data?.["hemp"]?.createdBy || "" // Show 'createdBy' from 'hemp' when 'all' is selected
                      : formData.data?.[fullRoleTab]?.createdBy || "" // Otherwise, show 'createdBy' for the specific platform
                  }
                  onChange={handleInputChange}
                  error={Boolean(errors?.createdBy)}
                  helperText={errors?.createdBy}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle fontSize="medium" color="secondary" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {subTrait?.data?.[fullRoleTab] &&
                subtraitSlug && <Grid item xs={12} md={4}>
                  <TextField
                    label="Trait Slug"
                    className="form-input"
                    fullWidth
                    placeholder="Trait Slug"
                    name="traitSlug"
                    value={
                      fullRoleTab === "all"
                        ? // Get the value from the first platform or default to empty
                        formData?.data?.[Object.keys(formData.data)[0]]?.traitSlug || ""
                        : formData.data?.[fullRoleTab]?.traitSlug || ""
                    }
                    onChange={handleInputChange}
                  />
                </Grid>
              }
              <Grid item xs={12} md={4}>
                <TextField
                  label="Trait Heading*"
                  fullWidth
                  variant="outlined"
                  name="traitHeading"
                  value={formData?.data?.[fullRoleTab]?.traitHeading}
                  onChange={handleInputChange}
                  error={Boolean(errors?.[fullRoleTab]?.traitHeading)} // Check if there's an error for this platform
                  helperText={errors?.[fullRoleTab]?.traitHeading}
                />
              </Grid>
            </Grid>
          </Card>

          {/********************** Contents Section when toggle on **********************/}
          {formData?.data?.[fullRoleTab]?.showOnHomePage && (
            <>
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
                <Typography variant="h5" fontWeight="semibold" mb={2}>
                  Meta Properties
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      label="Meta Title"
                      className="form-input"
                      fullWidth
                      placeholder="Meta Title"
                      name="metaTitle"
                      value={
                        fullRoleTab === "all"
                          ? // Get the value from the first platform or default to empty
                          formData.data[Object.keys(formData.data)[0]]?.metaTitle || ""
                          : formData.data[fullRoleTab]?.metaTitle || ""
                      }
                      onChange={handleInputChange}
                    />
                    <span className="drag_drop">
                      Character Count:{" "}
                      {fullRoleTab === "all"
                        ? formData?.data?.["hemp"]?.metaTitle?.length || 0
                        : formData?.data?.[fullRoleTab]?.metaTitle?.length || 0}{" "}
                      <span>(Recommended Characters: 60)</span>
                    </span>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    {/* <Typography variant='body2' fontWeight='medium' color="#2E2E3A" mb={1}>Meta Description</Typography> */}
                    <TextField
                      label="Meta Description"
                      className="form-input"
                      fullWidth
                      placeholder="Meta Description"
                      name="metaDescription"
                      value={
                        fullRoleTab === "all"
                          ? // Get the value from the first platform or default to empty
                          formData?.data?.[Object.keys(formData.data)[0]]?.metaDescription || ""
                          : formData?.data?.[fullRoleTab]?.metaDescription || ""
                      }
                      onChange={handleInputChange}
                    />
                    <span className="drag_drop">
                      Character Count:{" "}
                      {fullRoleTab === "all"
                        ? formData?.data?.["hemp"]?.metaDescription?.length || 0
                        : formData?.data?.[fullRoleTab]?.metaDescription?.length || 0}{" "}
                      <span>(Recommended Characters: 160)</span>
                    </span>
                  </Grid>
                </Grid>
              </Card>

              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
                <Typography variant="h5" fontWeight="semibold" mb={2}>
                  Content Section
                </Typography>
                
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Stack
                      fullWidth
                      direction="row"
                      alignItems="flex-start"
                      flexWrap="wrap"
                      gap={1.25}
                      mb={2}
                    >
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={5}>
                          <Box width="100%">
                            <Typography variant="body2" fontWeight="medium" mb={1} color="#2E2E3A">
                              Upload Image for list page (1920x300)
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={1}>
                              {formData?.data?.[fullRoleTab]?.listImage && (
                                <div style={{ position: 'relative' }}>
                                  <img
                                    src={
                                      fullRoleTab === "all"
                                        ? formData?.data[Object.keys(formData.data)[0]]?.listImage
                                        : formData?.data?.[fullRoleTab]?.listImage
                                    }
                                    alt="List Image"
                                    style={uploadThumbnailImage}
                                  />
                                  <IconButton
                                    onClick={handleDeleteListImage}
                                    sx={{
                                      position: "absolute",
                                      top: "-10px",
                                      right: "-10px",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      color: "#ff0000",
                                      fill: "#ff0000",
                                      backgroundColor: "#ffffff !important"
                                    }}
                                    size="small"
                                  >
                                    <DeleteIcon color="error" fontSize="small" />
                                  </IconButton>
                                </div>
                              )}

                              <label htmlFor="list-image-input">
                                <Box
                                  bgcolor="#F1F1F1"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  flexDirection="column"
                                  minWidth="160px"
                                  minHeight="160px"
                                  borderRadius="20px"
                                  p={2}
                                  sx={{ cursor: "pointer" }}
                                >
                                  {isUploading &&
                                    currentImageUploadFieldRef.current === "list_image" ? (
                                    <CircularProgress
                                      size={32}
                                      color="primary"
                                      sx={circularProgressIcon}
                                    />
                                  ) : (
                                    <Typography variant="body2" fontWeight="medium" textAlign="center">
                                      +<br />{" "}
                                      {formData?.data?.[fullRoleTab]?.listImage ? "Update" : "Add"}
                                    </Typography>
                                  )}
                                </Box>
                              </label>
                              <TextField
                                id="list-image-input"
                                type="file"
                                name="listImageFile"
                                onChange={listImageUploadHandler}
                                sx={{ display: "none" }}
                              />
                            </Stack>
                            {Boolean(errors?.listImage) && (
                              <FormHelperText error>{errors?.listImage}</FormHelperText>
                            )}
                            <Grid container mt={3}>
                              <Grid item xs={12} lg={6}>
                                <TextField
                                  label="Alt text for list image"
                                  fullWidth
                                  variant="outlined"
                                  name="listImageAlt"
                                  value={
                                    fullRoleTab === "all"
                                      ? // Get the value from the first platform or default to empty
                                      formData?.data?.[Object.keys(formData?.data)[0]]
                                        ?.listImageAlt || ""
                                      : formData.data?.[fullRoleTab]?.listImageAlt || ""
                                  }
                                  onChange={handleInputChange}
                                  error={Boolean(errors?.listImageAlt)}
                                  helperText={errors?.listImageAlt}
                                  className="form-input"
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={5}>
                          <Box width="100%">
                            <Typography variant="body2" fontWeight="medium" mb={1} color="#2E2E3A">
                              Upload Image for detail page (1920x300)
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={1}>
                              {formData?.data?.[fullRoleTab]?.detailImage && (
                                <div style={{ position: 'relative' }}>
                                  <img
                                    src={
                                      fullRoleTab === "all"
                                        ? formData?.data[Object.keys(formData.data)[0]]?.detailImage
                                        : formData?.data?.[fullRoleTab]?.detailImage
                                    }
                                    alt="Detail Page Image"
                                    style={uploadThumbnailImage}
                                  />
                                  <IconButton
                                    onClick={handleDeleteDetailImage}
                                    sx={{
                                      position: "absolute",
                                      top: "-10px",
                                      right: "-10px",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      color: "#ff0000",
                                      fill: "#ff0000",
                                      backgroundColor: "#ffffff !important"
                                    }}
                                    size="small"
                                  >
                                    <DeleteIcon color="error" fontSize="small" />
                                  </IconButton>
                                </div>
                              )}
                              <label htmlFor="detail-page-image-input">
                                <Box
                                  bgcolor="#F1F1F1"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  flexDirection="column"
                                  minWidth="160px"
                                  minHeight="160px"
                                  borderRadius="20px"
                                  p={2}
                                  sx={{ cursor: "pointer" }}
                                >
                                  {isUploading &&
                                    currentImageUploadFieldRef.current === "detail_page_image" ? (
                                    <CircularProgress
                                      size={32}
                                      color="primary"
                                      sx={circularProgressIcon}
                                    />
                                  ) : (
                                    <Typography variant="body2" fontWeight="medium" textAlign="center">
                                      +<br />{" "}
                                      {formData?.data?.[fullRoleTab]?.detailImage
                                        ? "Update"
                                        : "Add"}
                                    </Typography>
                                  )}
                                </Box>
                              </label>
                              <TextField
                                id="detail-page-image-input"
                                type="file"
                                name="productImageFile"
                                onChange={detailPageImageUploadHandler}
                                sx={{ display: "none" }}
                              />
                            </Stack>
                            {Boolean(errors?.detailImage) && (
                              <FormHelperText error>{errors?.detailImage}</FormHelperText>
                            )}
                            <Grid container mt={3}>
                              <Grid item xs={12} lg={6}>
                                <TextField
                                  label="Alt text for detail image"
                                  fullWidth
                                  variant="outlined"
                                  name="detailImageAlt"
                                  value={
                                    fullRoleTab === "all"
                                      ? // Get the value from the first platform or default to empty
                                      formData?.data?.[Object.keys(formData?.data)[0]]
                                        ?.detailImageAlt || ""
                                      : formData.data?.[fullRoleTab]?.detailImageAlt || ""
                                  }
                                  onChange={handleInputChange}
                                  error={Boolean(errors?.detailImageAlt)}
                                  helperText={errors?.detailImageAlt}
                                  className="form-input"
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <Stack
                      fullWidth
                      direction="row"
                      alignItems="flex-start"
                      flexWrap="wrap"
                      gap={1.25}
                      mb={2}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h6" fontWeight="semibold">
                            Product Detail Icon Images
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={5}>
                          <Box width="100%">
                            <Typography variant="body2" fontWeight="medium" mb={1} color="#2E2E3A">
                              Upload Icon for product detail page web(120x120)
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={1}>
                              {formData?.data?.[fullRoleTab]?.desktopIcon && (
                                <div style={{ position: 'relative' }}>
                                  <img
                                    src={
                                      fullRoleTab === "all"
                                        ? formData?.data[Object.keys(formData.data)[0]]?.desktopIcon
                                        : formData?.data?.[fullRoleTab]?.desktopIcon
                                    }
                                    alt="Desktop Icon"
                                    style={uploadThumbnailImage}
                                  />
                                  <IconButton
                                    onClick={handleDeleteDesktopIcon}
                                    sx={{
                                      position: "absolute",
                                      top: "-10px",
                                      right: "-10px",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      color: "#ff0000",
                                      fill: "#ff0000",
                                      backgroundColor: "#ffffff !important"
                                    }}
                                    size="small"
                                  >
                                    <DeleteIcon color="error" fontSize="small" />
                                  </IconButton>
                                </div>
                              )}
                              <label htmlFor="desktop-icon-input">
                                <Box
                                  bgcolor="#F1F1F1"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  flexDirection="column"
                                  minWidth="160px"
                                  minHeight="160px"
                                  borderRadius="20px"
                                  p={2}
                                  sx={{ cursor: "pointer" }}
                                >
                                  {isUploading &&
                                    currentImageUploadFieldRef.current === "desktop_icon" ? (
                                    <CircularProgress
                                      size={32}
                                      color="primary"
                                      sx={circularProgressIcon}
                                    />
                                  ) : (
                                    <Typography variant="body2" fontWeight="medium" textAlign="center">
                                      +<br />{" "}
                                      {formData?.data?.[fullRoleTab]?.desktopIcon
                                        ? "Update"
                                        : "Add"}
                                    </Typography>
                                  )}
                                </Box>
                              </label>
                              <TextField
                                id="desktop-icon-input"
                                type="file"
                                name="productImageFile"
                                onChange={desktopIconUploadHandler}
                                sx={{ display: "none" }}
                              />
                            </Stack>
                            {Boolean(errors?.desktopIcon) && (
                              <FormHelperText error>{errors?.desktopIcon}</FormHelperText>
                            )}
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={5}>
                          <Box width="100%">
                            <Typography variant="body2" fontWeight="medium" mb={1} color="#2E2E3A">
                              Upload Icon for product detail page mobile(100x100)
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={1}>
                              {formData?.data?.[fullRoleTab]?.mobileIcon && (
                                <div style={{ position: 'relative' }}>
                                  <img
                                    src={
                                      fullRoleTab === "all"
                                        ? formData?.data[Object.keys(formData.data)[0]]?.mobileIcon
                                        : formData?.data?.[fullRoleTab]?.mobileIcon
                                    }
                                    alt="Mobile Icon"
                                    style={uploadThumbnailImage}
                                  />
                                  <IconButton
                                    onClick={handleDeleteMobileIcon}
                                    sx={{
                                      position: "absolute",
                                      top: "-10px",
                                      right: "-10px",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      color: "#ff0000",
                                      fill: "#ff0000",
                                      backgroundColor: "#ffffff !important"
                                    }}
                                    size="small"
                                  >
                                    <DeleteIcon color="error" fontSize="small" />
                                  </IconButton>
                                </div>
                              )}
                              <label htmlFor="mobile-icon-input">
                                <Box
                                  bgcolor="#F1F1F1"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  flexDirection="column"
                                  minWidth="160px"
                                  minHeight="160px"
                                  borderRadius="20px"
                                  p={2}
                                  sx={{ cursor: "pointer" }}
                                >
                                  {isUploading &&
                                    currentImageUploadFieldRef.current === "mobile_icon" ? (
                                    <CircularProgress
                                      size={32}
                                      color="primary"
                                      sx={circularProgressIcon}
                                    />
                                  ) : (
                                    <Typography variant="body2" fontWeight="medium" textAlign="center">
                                      +<br />{" "}
                                      {formData?.data?.[fullRoleTab]?.mobileIcon ? "Update" : "Add"}
                                    </Typography>
                                  )}
                                </Box>
                              </label>
                              <TextField
                                id="mobile-icon-input"
                                type="file"
                                name="productImageFile"
                                onChange={mobileIconUploadHandler}
                                sx={{ display: "none" }}
                              />
                            </Stack>
                            {Boolean(errors?.mobileIcon) && (
                              <FormHelperText error>{errors?.mobileIcon}</FormHelperText>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <TextField
                      label="Tags*"
                      fullWidth
                      variant="outlined"
                      name="tags"
                      value={
                        fullRoleTab === "all"
                          ? formData?.data[Object.keys(formData?.data)[0]]?.tags?.join(",") || "" // Show tags from the first platform if "all"
                          : formData?.data?.[fullRoleTab]?.tags?.join(",") || "" // Show tags for the selected platform
                      }
                      onChange={(e) => {
                        const newTags = e.target.value ? e.target.value.split(",") : [];

                        setFormData((prevData) => {
                          if (fullRoleTab === "all") {
                            // If "all" is selected, update the tags for all platforms
                            const updatedData = { ...prevData.data };

                            Object.keys(updatedData).forEach((platform) => {
                              updatedData[platform] = {
                                ...updatedData[platform],
                                tags: newTags, // Update tags for all platforms
                              };
                            });

                            return {
                              ...prevData,
                              data: updatedData,
                            };
                          } else {
                            // Update only the selected platform's tags
                            return {
                              ...prevData,
                              data: {
                                ...prevData.data,
                                [fullRoleTab]: {
                                  ...prevData.data[fullRoleTab],
                                  tags: newTags,
                                },
                              },
                            };
                          }
                        });
                      }}
                      error={Boolean(errors?.tags)}
                      helperText={errors?.tags}
                    />
                  </Grid>

                  {formData?.data?.[fullRoleTab]?.tags?.length > 0 && (
                    <Grid item xs={12} sm={12} lg={12}>
                      <Stack
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        gap="10px"
                        flexWrap="wrap"
                        my={2}
                      >
                        {/* When "all" is selected, show tags from the first platform */}
                        {(fullRoleTab === "all"
                          ? formData?.data[Object.keys(formData?.data)[0]]?.tags || [] // Show tags from the first platform
                          : formData?.data[fullRoleTab]?.tags || []
                        ).map((tag, tagIndex) => {
                          if (!tag) return null;
                          return (
                            <Box
                              key={tagIndex}
                              sx={{ bgcolor: "#F2F3F7", px: 2, py: 0.75, borderRadius: 2 }}
                            >
                              <Typography
                                fontWeight="medium"
                                color="dark"
                                className="fs-x-small d-flex align-item-center gap-1"
                              >
                                <span>{tag}</span>
                                <CancelIcon
                                  onClick={() => {
                                    setFormData((prevData) => {
                                      const updatedData = { ...prevData.data };

                                      if (fullRoleTab === "all") {
                                        // If "all" is selected, remove the tag from all platforms
                                        Object.keys(updatedData).forEach((platform) => {
                                          updatedData[platform].tags = updatedData[
                                            platform
                                          ].tags.filter((t, index) => index !== tagIndex);
                                        });
                                      } else {
                                        // If a specific platform is selected, remove the tag from that platform
                                        updatedData[fullRoleTab].tags = updatedData[
                                          fullRoleTab
                                        ].tags.filter((t, index) => index !== tagIndex);
                                      }

                                      return {
                                        ...prevData,
                                        data: updatedData,
                                      };
                                    });
                                  }}
                                  color="error"
                                  style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                />
                              </Typography>
                            </Box>
                          );
                        })}
                      </Stack>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>
                      Title
                    </Typography>
                    <CommonQuillEditor
                      value={
                        fullRoleTab === "all"
                          ? formData?.data?.[Object.keys(formData.data)[0]]?.title || ""
                          : formData?.data?.[fullRoleTab]?.title || ""
                      }
                      onChange={(value) => {
                        if (fullRoleTab === "all") {
                          // Update the title for all platforms
                          setFormData((prevData) => {
                            const updatedData = { ...prevData.data };
                            Object.keys(updatedData).forEach((platform) => {
                              updatedData[platform] = {
                                ...updatedData[platform],
                                title: value,
                              };
                            });
                            return {
                              ...prevData,
                              data: updatedData,
                            };
                          });
                        } else {
                          // Update the title for the selected platform
                          setFormData((prevData) => ({
                            ...prevData,
                            data: {
                              ...prevData.data,
                              [fullRoleTab]: {
                                ...prevData.data[fullRoleTab],
                                title: value,
                              },
                            },
                          }));
                        }
                      }}
                    />
                    {/* {
                              errors?.title && <FormHelperText error>{errors?.title}</FormHelperText>
                            } */}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>
                      Description1
                    </Typography>
                    <CommonQuillEditor
                      style={true} height={"300px"}
                      value={
                        fullRoleTab === "all"
                          ? formData.data[Object.keys(formData.data)[0]]?.description1 || ""
                          : formData.data[fullRoleTab]?.description1 || ""
                      }
                      onChange={(value) => {
                        if (fullRoleTab === "all") {
                          // Update description1 for all platforms
                          setFormData((prevData) => {
                            const updatedData = { ...prevData.data };
                            Object.keys(updatedData).forEach((platform) => {
                              updatedData[platform] = {
                                ...updatedData[platform],
                                description1: value,
                              };
                            });
                            return {
                              ...prevData,
                              data: updatedData,
                            };
                          });
                        } else {
                          // Update description1 for the selected platform
                          setFormData((prevData) => ({
                            ...prevData,
                            data: {
                              ...prevData.data,
                              [fullRoleTab]: {
                                ...prevData.data[fullRoleTab],
                                description1: value,
                              },
                            },
                          }));
                        }
                      }}
                    />
                    {errors?.description1 && (
                      <FormHelperText error>{errors?.description1}</FormHelperText>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>
                      Description2
                    </Typography>
                    <CommonQuillEditor
                      style={true} height={"300px"}
                      value={
                        fullRoleTab === "all"
                          ? formData.data[Object.keys(formData.data)[0]]?.description2 || ""
                          : formData.data[fullRoleTab]?.description2 || ""
                      }
                      onChange={(value) => {
                        if (fullRoleTab === "all") {
                          // Update description2 for all platforms
                          setFormData((prevData) => {
                            const updatedData = { ...prevData.data };
                            Object.keys(updatedData).forEach((platform) => {
                              updatedData[platform] = {
                                ...updatedData[platform],
                                description2: value,
                              };
                            });
                            return {
                              ...prevData,
                              data: updatedData,
                            };
                          });
                        } else {
                          // Update description2 for the selected platform
                          setFormData((prevData) => ({
                            ...prevData,
                            data: {
                              ...prevData.data,
                              [fullRoleTab]: {
                                ...prevData.data[fullRoleTab],
                                description2: value,
                              },
                            },
                          }));
                        }
                      }}
                    />
                    {errors?.description2 && (
                      <FormHelperText error>{errors?.description2}</FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </>
          )}

          {/********************** Save, Cancel Buttons **********************/}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={2} mb={2}>
                {/* <MDButton
                  sx={{ minWidth: "160px" }}
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  loading={loading}
                  disabled={loading}
                >
                  {subtraitSlug ? "Update" : "Save"}
                </MDButton> */}
                {subtraitSlug ? (
                  <MDButton
                    sx={{ minWidth: "160px" }}
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={loading || !canEdit}
                  >
                    Update
                  </MDButton>
                ) : (
                  <MDButton
                    sx={{ minWidth: "160px" }}
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={loading || !canCreate}
                  >
                    Save
                  </MDButton>
                )}
                {
                  subtraitSlug && <MDButton
                    disabled={!canDelete ? true : false}
                    sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                    type='button'
                    variant='contained'
                    color='error'
                    onClick={() => {
                      dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: subtraitSlug }, modal: 'DELETE_MODAL' }));
                    }}
                  >
                    Delete
                  </MDButton>
                }
                <MDButton
                  sx={{ minWidth: "160px" }}
                  type="button"
                  variant="outlined"
                  color="dark"
                  onClick={() => navigate("/product_traits/subtrait")}
                >
                  Cancel
                </MDButton>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default AddSubTraitForm;
